// eslint-disable-next-line import/prefer-default-export
export const UNKNOWN_STOP = 'Unknown Stop';
